import { apiClient } from 'src/utils/api-client';
import {
  AddressModel,
  CoverageAreaAddressModel,
  HomeownerLead,
} from './models';
import { trackEventService } from './tracking';

export function createHomeownerLeadService(lead: HomeownerLead) {
  return apiClient.post<void>('/homeowners/leads', lead);
}

export function checkCoverageService(addressList: AddressModel[]) {
  return apiClient.post<CoverageAreaAddressModel[]>(
    '/homeowners/leads/checkcoverage',
    addressList,
  );
}

export function trackPersonalDetailsService(details: Record<string, string>) {
  return trackEventService({
    eventName: 'SignUpDetailsFilled',
    metadata: details,
  });
}
